import { InstanceDetailForm } from '../instance-detail-form/InstanceDetailForm';
import { useInstance } from '../InstanceContext';

/**
 * "Details" tab on the Instance Detail page. Consumes the subscription from
 * the page-level outlet context so the data is fetched once for all sections.
 */
export const DetailsSection = () => {
    const { subscription } = useInstance();
    return <InstanceDetailForm subscription={subscription} />;
};
